module.exports = new __parcel__URL__("cauldron.34955e75.webp").toString();